import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { getQueryValueAsString } from "@vc-workspace/utils-helpers";
import GlobalContextWrapper from "../../../components/global-context-wrapper/global-context-wrapper";
import BasicSEO from "../../../components/seo/BasicSEO";
import ProductReviewsSection from "../../../components/product-reviews-section/product-reviews-section";
import ProductReviewsHeader from "../../../components/product-reviews-header/product-reviews-header";
import { useEffect } from "react";
import { AmplitudeEventNames, sendAmplitudeData } from "@vc-workspace/utils-amplitude";
import { DisplayReviewTypes, PageTypes, SourceKey, SourceNameKey } from "@vc-workspace/utils-constants";
export var __N_SSP = true;
export function ProductReviews(_ref) {
  var context = _ref.context,
      productDetails = _ref.productDetails;
  useEffect(function () {
    sendAmplitudeData(AmplitudeEventNames.REVIEW_VIEWED, {
      page_type: PageTypes.PRODUCT_REVIEW_PAGE,
      review_type: DisplayReviewTypes.PRODUCT,
      item_us_id: productDetails.sia.itemDetail.usId,
      product_name: productDetails.sia.itemDetail.name,
      l0_category: productDetails.sia.itemDetail.l0CategoryNames,
      l1_category: productDetails.sia.itemDetail.l1CategoryNames,
      l2_category: productDetails.sia.itemDetail.l2CategoryNames,
      shop_name: productDetails.sia.shopName,
      source: getQueryValueAsString(context.query, SourceKey),
      source_name: getQueryValueAsString(context.query, SourceNameKey)
    });
  }, []);
  return /*#__PURE__*/_jsxs(GlobalContextWrapper, {
    context: context,
    disableNavActions: true,
    disableCategoryFetch: true,
    hideAppDownloadBanner: true,
    children: [/*#__PURE__*/_jsx(BasicSEO, {
      title: "".concat(productDetails.sia.itemDetail.name, " Reviews")
    }), /*#__PURE__*/_jsxs("div", {
      className: "page-profile-wrapper pure-g ".concat(context.isMobileView ? "" : "pt-16"),
      children: [!context.isMobileView ? /*#__PURE__*/_jsx("div", {
        className: context.isMobileView ? "pure-u-1" : "pure-u-2-5",
        children: /*#__PURE__*/_jsx(ProductReviewsHeader, {
          sia: productDetails.sia
        })
      }) : /*#__PURE__*/_jsx("div", {
        className: "pt-4 pure-u-1"
      }), /*#__PURE__*/_jsx("div", {
        className: context.isMobileView ? "pure-u-1" : "pure-u-3-5 pl-16",
        children: /*#__PURE__*/_jsx(ProductReviewsSection, {
          sia: productDetails.sia,
          context: context,
          reviewData: productDetails.reviewData
        })
      })]
    })]
  });
}
export default ProductReviews;